import { render, staticRenderFns } from "./model-modal.vue?vue&type=template&id=2476b38e&scoped=true"
import script from "./model-modal.vue?vue&type=script&lang=js"
export * from "./model-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2476b38e",
  null
  
)

export default component.exports